import script from "./WALoading.vue?vue&type=script&setup=true&lang=js"
export * from "./WALoading.vue?vue&type=script&setup=true&lang=js"

import "./WALoading.vue?vue&type=style&index=0&id=715dbbdf&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715dbbdf"]])

export default __exports__